import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref,onMounted,watch} from "vue";
    
export default /*@__PURE__*/_defineComponent({
  __name: 'slider',
  props: {
        num: Number,
        max:Number,
    },
  emits: ['updataNum'],
  setup(__props, { emit: __emit }) {

    const props = __props
    // console.log(props.num)
    // console.log(props.max)
    const bar = ref<HTMLElement>();
    const Pos = ref("left: 0;");
    const leftNum=ref(0)
    watch(() => props.num, (n, o) =>{
        // console.log('watch'+n)
        if(n>props.max){
            moveNum()
            return
        }else if(n<0){
            moveNum()
            return
        }
        let w = bar.value.clientWidth;
        leftNum.value=(n/props.max)*w
        Pos.value = `left: ${leftNum.value}px;`;
    })
    // 初始化状态
     onMounted(()=>{
        let w = bar.value.clientWidth;
        leftNum.value=(props.num/props.max)*w
        Pos.value = `left: ${leftNum.value}px;`;
    })
    const emit = __emit
    const moveNum=()=>{
        let w = bar.value.clientWidth;
        emit('updataNum',Math.ceil((leftNum.value/w)*props.max))
    }
    // 点击后添加事件
    const mousedown = () => {
        window.addEventListener("mousemove", handleChange);
        window.addEventListener("mouseup", mouseup);
        // window.addEventListener("mouseleave", mouseup);
        
    };
    // 移动滑块
    const handleChange = (e: any) => {
        if (!bar.value) return;
        // 获取滑块的宽度（可移动区域）
        let w = bar.value.clientWidth;
        // 获取鼠标的位置
        let x = e.pageX - bar.value.getBoundingClientRect().left;
        // 判断是否超出范围
        // x = x < w && x > 0 ? x : x > w ? w : 0;
        if(x > w){
            x=w
        }else if(x<0){
            x=0
        }
        leftNum.value=x
        Pos.value = `left: ${leftNum.value}px;`;
        moveNum()
    };
    // 鼠标放开后移除事件
    const mouseup = () => {
        document.ondragstart = function(ev) {
            ev.preventDefault();
        };
        document.ondragend = function(ev) {
            ev.preventDefault();
        };
        window.removeEventListener("mousemove", handleChange);
        window.removeEventListener("mouseup", mouseup);
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "bar",
    ref_key: "bar",
    ref: bar
  }, [
    _createElementVNode("div", {
      class: "sliderBar",
      style: _normalizeStyle({'width':leftNum.value+'px'})
    }, null, 4),
    _createElementVNode("div", {
      class: "slider",
      style: _normalizeStyle(Pos.value),
      onMousedown: mousedown
    }, null, 36)
  ], 512))
}
}

})